// api
import { fetchApi } from '@/api'

import router from '@/router'
// actions
const schoolRoutesDriversAll = (context) => {
  let url = 'schoolroutes/drivers'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTERS_DRIVERS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
            console.error(error)
    })
}

const schoolRoutesDriversForm = (context) => {
  let url = 'schoolroutes/drivers/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTERS_DRIVERS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
            console.error(error)
    })
}

const schoolRoutesDriversShow = (context,payload) => {
  let obj = JSON.parse(payload)
  let url = 'schoolroutes/drivers/'+ obj.id + '/edit'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTERS_DRIVERS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
            console.error(error)
    })
}

// actions
const schoolRoutesDriversCreate = (context,payload) => {
  let url = 'schoolroutes/drivers'
  let data = {}
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('SCHOOLROUTERS_DRIVERS_CREATE', response)
      router.push('/schoolroutes/drivers/list')
    })
    .catch((error) => {
      // eslint-disable-next-line
            console.error(error)
    })
}

const schoolRoutesDriversUpdate = (context,payload) => {
  let obj = JSON.parse(payload)
  let url = 'schoolroutes/drivers/'+ obj.id
  let data = {}
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('SCHOOLROUTERS_DRIVERS_UPDATE', response)
      router.push('/schoolroutes/drivers/list')
    })
    .catch((error) => {
      // eslint-disable-next-line
            console.error(error)
    })
}

const schoolRoutesDriversDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'schoolroutes/drivers' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('SCHOOLROUTERS_DRIVERS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
            console.error(error)
    })
}

export default {
  schoolRoutesDriversAll,
  schoolRoutesDriversForm,
  schoolRoutesDriversShow,
  schoolRoutesDriversCreate,
  schoolRoutesDriversUpdate,
  schoolRoutesDriversDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/drivers/actions.js